import React, { useCallback, useRef } from 'react'
import Draggable from 'react-draggable'
import Paper from '@mui/material/Paper'

const DraggableDialog = ({ ref: forwardedRef, ...props }: any) => {
    const nodeRef = useRef<HTMLDivElement>(null)
    const setRef = useCallback(
        (element: HTMLDivElement | null) => {
            (nodeRef as React.MutableRefObject<HTMLDivElement | null>).current = element
            if (forwardedRef) {
                if (typeof forwardedRef === 'function') forwardedRef(element)
                else (forwardedRef as React.MutableRefObject<HTMLDivElement | null>).current = element
            }
        },
        [forwardedRef]
    )
    return (
        <Draggable
            nodeRef={nodeRef}
            handle=".draggable-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={setRef} />
        </Draggable>
    )
}

export default DraggableDialog
